module.exports = "<svg-icon #icon [src]=\"src\"></svg-icon>\n"